import PropTypes from 'prop-types'

import AtomButton from '@s-ui/react-atom-button'
import {useRouter} from '@s-ui/react-router'
import SearchSave from '@adv-mt/mt-search-save'

import {BASE_CLASS} from './config.js'

const TOOLTIP_DELAY = 9000
const TRACKING_ORIGIN_SEARCH_MODAL = 'Filter View Alert Created'

const CustomRenderActions = ({
  acceptButtonOptions = {},
  acceptButtonText,
  hasAcceptButton = true,
  hasZeroResults = false,
  onAccept = {},
  search,
  isSearchModal = false,
  isLoading,
  showSearchSave = true
}) => {
  const router = useRouter()

  const handleRedirectTo = url => {
    router.push(url)
  }

  return (
    <div className={`${BASE_CLASS}-customRenderActions`}>
      {showSearchSave && (
        <SearchSave
          delay={TOOLTIP_DELAY}
          isFullWidth={false}
          search={search}
          redirectTo={handleRedirectTo}
          isSearchModal={isSearchModal}
          hasZeroResults={hasZeroResults}
          trackingOrigin={TRACKING_ORIGIN_SEARCH_MODAL}
          createAlertAfterLogin
        />
      )}
      {hasAcceptButton && (
        <AtomButton onClick={onAccept} {...acceptButtonOptions} isLoading={isLoading}>
          {acceptButtonText}
        </AtomButton>
      )}
    </div>
  )
}

CustomRenderActions.displayName = 'CustomRenderActions'

CustomRenderActions.propTypes = {
  acceptButtonOptions: PropTypes.object,
  acceptButtonText: PropTypes.string,
  hasAcceptButton: PropTypes.bool,
  hasZeroResults: PropTypes.bool,
  onAccept: PropTypes.func,
  search: PropTypes.object,
  isSearchModal: PropTypes.bool,
  isLoading: PropTypes.bool,
  showSearchSave: PropTypes.bool
}

export default CustomRenderActions
